
.MultiDaySlotLayout {
    --Week__stepWidth--s: 2.3rem;
    --Week__stepWidth--m: 4rem;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    z-index: 1;
}

.MultiDaySlotLayout__header {
    display: grid;
    grid-template-columns: var(--Week__stepWidth--s) repeat(var(--Week-days), 1fr);

    @media (min-width: 900px) {
        grid-template-columns: var(--Week__stepWidth--m) repeat(var(--Week-days), 1fr);
    }
}

.MultiDaySlotLayout__body {
    height: auto;
    display: block;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
}

.MultiDaySlotLayout__days {
    display: grid;
    grid-template-columns: var(--Week__stepWidth--s) repeat(var(--Week-days), 1fr);

    @media (min-width: 900px) {
        grid-template-columns: var(--Week__stepWidth--m) repeat(var(--Week-days), 1fr);
    }
}

.MultiDaySlotLayout__timeSlotHeaders {
    display: flex;
    flex-direction: column;
}

.MultiDaySlotLayout__timeSlotGuides {
    display: flex;
    position: absolute;
    z-index: -1;
    inset: 0;
    flex-direction: column;
    pointer-events: none;
}

.MultiDaySlotLayout__timeSlotGuide {
    &:before {
        display: block;
        content: '';
        height: var(--Week__slotHeight);
        border-top: solid 1px var(--soniq-t--global--border--color--grid--default, #efefef);
    }

    &:nth-child(2n-1):before {
        border-top-color: var(--soniq-t--global--border--color--grid--strong);
    }
}

